import { TermsAndConditionsComponent } from './page/customer/terms-and-conditions/terms-and-conditions.component';
import { ResetPasswordComponent } from './page/customer/reset-password/reset-password.component';
import { ForgotPasswordComponent } from './page/customer/forgot-password/forgot-password.component';
import { ThankYouComponent } from './page/booking/thank-you/thank-you.component';
import { AppConstants } from './app.constants';
import { RouterModule, Routes } from '@angular/router';
import { MainComponent } from './layout/main/main.component';
import { SelectConsultationComponent } from './page/booking/select-consultation/select-consultation.component';
import { SelectPractitionerComponent } from './page/booking/select-practitioner/select-practitioner.component';
import { LoginComponent } from './page/customer/login/login.component';
import { RegisterComponent } from './page/customer/register/register.component';
import { ServiceConfirmationComponent } from './page/booking/service-confirmation/service-confirmation.component';
import { SelectDateAndTimeComponent } from './page/booking/select-date-and-time/select-date-and-time.component';
import { NgModule } from '@angular/core';
import { VerifyEmailAddressComponent } from './page/customer/verify-email-address/verify-email-address.component';
import { MigrateCustomerComponent } from './page/customer/migrate-customer/migrate-customer.component';
import { ProfileComponent } from './page/customer/profile/profile.component';
import { ChangePasswordComponent } from './page/customer/change-password/change-password.component';
import { LogoutComponent } from './page/customer/logout/logout.component';
import { InvalidComponent } from './page/invalid/invalid.component';
import { CovidComponent } from './page/covid/covid.component';
import { VisitorGuard } from './guards/visitor.guard';
import { CustomerGuard } from './guards/customer.guard';
import { GiftVoucherRedemptionComponent } from './page/booking/gift-voucher-redemption/gift-voucher-redemption.component';
import { GiftVoucherCartComponent } from './page/gift-voucher/gift-voucher-cart/gift-voucher-cart.component';
import { GiftVoucherCheckoutComponent } from './page/gift-voucher/gift-voucher-checkout/gift-voucher-checkout.component';
import { GiftVoucherDetailsComponent } from './page/gift-voucher/gift-voucher-details/gift-voucher-details.component';
import { GiftVoucherHomeComponent } from './page/gift-voucher/gift-voucher-home/gift-voucher-home.component';
import { GiftVoucherThankYouComponent } from './page/gift-voucher/gift-voucher-thank-you/gift-voucher-thank-you.component';
import { IncomingBookingComponent } from './page/customer/incoming-booking/incoming-booking.component';
import { TransactionHistoryComponent } from './page/customer/transaction-history/transaction-history.component';
import { RescheduleComponent } from './page/customer/reschedule/reschedule.component';
import { UpdateEmailAddressComponent } from './page/customer/update-email-address/update-email-address.component';

export const routes: Routes = [
    {
        path: '', component: MainComponent,
        children: [
            {
                path: '',
                redirectTo: AppConstants.RouteSelectConsultation,
                pathMatch: 'full'
            },

            { path: AppConstants.RouteInvalid, component: InvalidComponent },
            { path: AppConstants.RouteCovid, component: CovidComponent },
            { path: AppConstants.RouteTermsAndConditions, component: TermsAndConditionsComponent },

            { path: AppConstants.RouteSelectConsultation, component: SelectConsultationComponent, canActivate: [CustomerGuard] },
            { path: AppConstants.RouteSelectPractitioner, component: SelectPractitionerComponent, canActivate: [CustomerGuard] },
            { path: AppConstants.RouteSelectDate, component: SelectDateAndTimeComponent, canActivate: [CustomerGuard] },

            { path: AppConstants.RouteServiceConfirmation, component: ServiceConfirmationComponent, canActivate: [CustomerGuard] },
            { path: AppConstants.RouteGiftVoucherRedemption, component: GiftVoucherRedemptionComponent, canActivate: [CustomerGuard] },
            { path: AppConstants.RouteThankYou, component: ThankYouComponent, canActivate: [CustomerGuard] },

            { path: AppConstants.RouteLogin, component: LoginComponent, canActivate: [VisitorGuard] },
            { path: AppConstants.RouteRegister, component: RegisterComponent, canActivate: [VisitorGuard] },
            { path: AppConstants.RouteForgotPassword, component: ForgotPasswordComponent, canActivate: [VisitorGuard] },
            { path: AppConstants.RouteResetPassword, component: ResetPasswordComponent, canActivate: [VisitorGuard] },
            { path: AppConstants.RouteVerifyEmailAddress, component: VerifyEmailAddressComponent, canActivate: [VisitorGuard] },
            { path: AppConstants.RouteUpdateEmailAddress, component: UpdateEmailAddressComponent, canActivate: [CustomerGuard] },
            { path: AppConstants.RouteMigrateCustomer, component: MigrateCustomerComponent, canActivate: [VisitorGuard] },

            { path: AppConstants.RouteLogout, component: LogoutComponent, canActivate: [CustomerGuard] },
            { path: AppConstants.RouteChangePassword, component: ChangePasswordComponent, canActivate: [CustomerGuard] },
            { path: AppConstants.RouteProfile, component: ProfileComponent, canActivate: [CustomerGuard] },
            { path: AppConstants.RouteTransactionHistory, component: TransactionHistoryComponent, canActivate: [CustomerGuard] },
            { path: AppConstants.RouteIncomingAppointment, component: IncomingBookingComponent, canActivate: [CustomerGuard] },
            { path: AppConstants.RouteReSchedule, component: RescheduleComponent, canActivate: [CustomerGuard] },
            
            { path: AppConstants.RouteGiftVouchers, component: GiftVoucherHomeComponent, canActivate: [CustomerGuard]  },            
            { path: AppConstants.RouteGiftVoucher, component: GiftVoucherDetailsComponent, canActivate: [CustomerGuard]  },   
            { path: AppConstants.RouteCart, component: GiftVoucherCartComponent, canActivate: [CustomerGuard]  }, 
            { path: AppConstants.RouteCheckout, component: GiftVoucherCheckoutComponent, canActivate: [CustomerGuard]  },
            { path: AppConstants.RouteGvThankYou, component: GiftVoucherThankYouComponent, canActivate: [CustomerGuard]  },

            { path: '**', component: InvalidComponent }
        ]
    },
];

@NgModule({
    imports: [
        RouterModule.forRoot(routes)
    ],
    exports: [RouterModule]
})
export class AppRoutingModule {

}

